import React, {Component} from 'react';
import {withSession} from "../Session/context";
import {withFirebase} from "../Firebase";
import Option from "../Option";
import Header from "../Header";
import {Link} from "react-router-dom";

class PageProjects extends Component {
    componentDidMount() {
        this.props.firebase.getProjects().then(projects => {
           this.setState({ projects: projects })
        });
    }
    render() {

        const listItems = this.state && this.state.projects.map((project) => {
            return (
                <Link to={`/project/${project.id}`}>
                    <Option key={project.id} title={project.title} />
                </Link>
            )
        });

        return (
            <div>
                <Header title={"Choose an app"} subtitle={"Translate"} />
                {listItems}
            </div>
        );
    }
}

export default withSession(withFirebase(PageProjects));